import { createSlice } from "@reduxjs/toolkit"

const emptyToastFields = {
  message: "",
  subtext: null,
  actionLabel: null,
  actionPath: null,
  richPlan: null,
}

function parseRichPlan(raw) {
  if (
    !raw ||
    (raw.kind !== "schedule" && raw.kind !== "draft") ||
    raw.dateLabel == null ||
    String(raw.dateLabel).trim() === ""
  ) {
    return null
  }
  return {
    kind: raw.kind,
    count: Math.max(1, Math.floor(Number(raw.count)) || 1),
    dateLabel: String(raw.dateLabel).trim(),
  }
}

const successToastSlice = createSlice({
  name: "successToast",
  initialState: {
    visible: false,
    ...emptyToastFields,
  },
  reducers: {
    showSuccessToast: (state, { payload }) => {
      if (typeof payload === "string") {
        const message = payload.trim()
        if (!message) return
        state.visible = true
        state.message = message
        state.subtext = null
        state.actionLabel = null
        state.actionPath = null
        state.richPlan = null
        return
      }
      if (!payload || typeof payload !== "object") return

      const richPlan = parseRichPlan(payload.richPlan)
      const message = payload.message != null ? String(payload.message).trim() : ""
      if (!message && !richPlan) return

      state.visible = true
      state.message = message
      state.subtext =
        payload.subtext != null && String(payload.subtext).trim() !== ""
          ? String(payload.subtext).trim()
          : null
      state.actionLabel =
        payload.actionLabel != null && String(payload.actionLabel).trim() !== ""
          ? String(payload.actionLabel).trim()
          : null
      state.actionPath =
        payload.actionPath != null && String(payload.actionPath).trim() !== ""
          ? String(payload.actionPath).trim()
          : null
      state.richPlan = richPlan
    },
    dismissSuccessToast: (state) => {
      state.visible = false
      Object.assign(state, emptyToastFields)
    },
  },
})

export const { showSuccessToast, dismissSuccessToast } = successToastSlice.actions
export default successToastSlice.reducer
